import { h } from 'preact';
import clsx from 'clsx';

const TimeUnit = ({ value, unit, isGold }) => {
  const formatNumber = (num) => String(num).padStart(2, '0');
  return (
    <div className="flex flex-col gap-[5px] items-center justify-center">
      <div
        className={clsx(
          'w-[70px] h-10 flex items-center justify-center rounded-sm border backdrop-blur-[20px]',
          {
            'spd-heading-5 laptop:spd-heading-6 border-spd-grey-100/[.15] bg-black/[.08]':
              !isGold,
            'gld-heading-5 laptop:gld-heading-6 border-black/[.15] bg-white':
              isGold,
          },
        )}
      >
        <span
          className={clsx({
            'spd-heading-5 laptop:spd-heading-6': !isGold,
            'gld-heading-5 laptop:gld-heading-6 pt-[5px]': isGold,
          })}
        >
          {formatNumber(value)}
        </span>
      </div>
      <div
        className={clsx(
          {
            'spd-utility font-bold': !isGold,
            'gld-utility font-bold text-white': isGold,
          },
          'uppercase leading-[18px]',
        )}
      >
        {value === 1 ? unit.singular : unit.plural}
      </div>
    </div>
  );
};

export default TimeUnit;
